const bcnSede = [
  {
    id: "bcnSede",
    isInline: true,
    title: {
      es: "Sede Barcelona",
      cat: "Sede Barcelona",
    },
    items: [
      {
        link: {
          es: "https://www.thesocialhub.co/es/",
          cat: "https://www.thesocialhub.co/es/",
        },
        title: "The social hub",
        image: "social-hub.png",
        size: 1.5,
        original: true,
      },
    ],
  },
];

export default bcnSede;
